export const TEST_ID_TOPBAR_STEPPER_STEP = 'topbar-stepper-step';
